<template>
  <div id="scisure-datepicker">
    <v-date-picker
      v-model="localRecordDate"
      :is-required="isRequired"
      :class="className"
      :min-date="minDate"
      :max-date="maxDate"
      :model-config="modelConfig"
      :masks="masks"
      timezone="utc"
    >
      <template #default="{ inputValue, inputEvents }">
        <input
          :value="inputValue"
          v-on="inputEvents"
          :id="inputValueId"
          :name="inputValueName"
        />
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  name: "SciSureDatePicker",
  data() {
    return {
      localRecordDate: this.recordDate,
      modelConfig: {
        type: "date",
        format: "YYYY-MM-DD",
      },
      masks: {
        input: "YYYY-MM-DD",
      },
      maxDate: this.isMaxDate ? this.todayEnd() : null,
    };
  },
  props: {
    recordDate: {
      type: [String, Date],
      default: "",
    },
    className: {
      type: String,
      default: "date-picker-wrapper",
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    minDate: {
      type: Date,
      default: null,
    },
    isMaxDate: {
      type: Boolean,
      default: false,
    },
    payloadType: {
      type: String,
      required: true,
      default: "date",
    },
  },
  watch: {
    localRecordDate(newVal) {
      let emitVal = newVal;
      if (this.payloadType === "string" && newVal) {
        emitVal = this.dateWithoutTime(newVal);
      }
      // Normalize both for comparison
      let currentVal = this.recordDate;
      if (this.payloadType === "string" && currentVal) {
        currentVal = this.dateWithoutTime(currentVal);
      }
      if (emitVal !== currentVal) {
        this.$emit("update-record-date", emitVal);
      }
    },
    recordDate(newVal) {
      // Only update if different (normalize for comparison)
      let localVal = this.localRecordDate;
      if (this.payloadType === "string" && localVal) {
        localVal = this.dateWithoutTime(localVal);
      }
      let newValNorm = newVal;
      if (this.payloadType === "string" && newVal) {
        newValNorm = this.dateWithoutTime(newVal);
      }
      if (localVal !== newValNorm) {
        this.localRecordDate = newVal;
      }
    },
  },
  computed: {
    inputValueId() {
      return this.className + "-input-date";
    },
    inputValueName() {
      return this.className + "-input-date";
    },
  },
  methods: {
    dateWithoutTime(date) {
      const newDate = new Date(date);
      // Format as "Y-m-d"
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    todayEnd() {
      const now = new Date();
      // Get today's date in UTC
      const year = now.getUTCFullYear();
      const month = now.getUTCMonth();
      const day = now.getUTCDate();
      // Set to end of today in UTC
      return new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
    },
  },
};
</script>

<style scoped></style>
